import { render, staticRenderFns } from "./SplitAccount.vue?vue&type=template&id=593876c5&scoped=true"
import script from "./SplitAccount.vue?vue&type=script&lang=js"
export * from "./SplitAccount.vue?vue&type=script&lang=js"
import style0 from "./SplitAccount.vue?vue&type=style&index=0&id=593876c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "593876c5",
  null
  
)

export default component.exports